import { Camera, CameraResultType, CameraSource } from '@capacitor/camera';

import { fotoImBrowser } from './fotoWeb';
import { istGeraet } from './gleis';
import { saveBase64, type FileSubject, type LogScope } from './storage';

/**
 * Foto aufnehmen und ablegen.
 *
 * Bewusst `CameraSource.Camera` statt `Prompt`: im Prüfungsbetrieb soll der Knopf die Kamera
 * öffnen und nicht erst fragen, ob es aus der Fotobibliothek kommen soll. Was dort liegt,
 * gehört nicht zu dieser Prüfung.
 */
export async function capturePhoto(
  scope: LogScope,
  subject: FileSubject,
): Promise<{ path: string } | null> {
  if (!istGeraet()) {
    const bild = await fotoImBrowser();
    return bild ? { path: await saveBase64(scope, 'photo', subject, bild.format, bild.base64) } : null;
  }
  const photo = await Camera.getPhoto({
    quality: 82,
    resultType: CameraResultType.Base64,
    source: CameraSource.Camera,
    // Zuschneiden würde einen zweiten Bildschirm einschieben; hier zählt Tempo.
    allowEditing: false,
    saveToGallery: false,
  });

  if (!photo.base64String) return null;
  const path = await saveBase64(scope, 'photo', subject, photo.format || 'jpeg', photo.base64String);
  return { path };
}
